import {abstractForm} from './abstractForm';
import {Injectable} from '@angular/core';
import {Validators} from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class ForgotPassword extends abstractForm{

  getForm() {
    const emailValidators = [];
    emailValidators.push(Validators.pattern);
    emailValidators.push(Validators.required);
    return {
      id: ['', Validators.compose(emailValidators)]
    };
  }

}
